import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import swal from "sweetalert";
import { GetNameChoose } from "../../../funcUtils";
import chen from "./img/chen.png";
import dia from "./img/dia.png";
import "../XDia/xd.css";
import "./tx.css";

function TX60s() {
    const navigate = useNavigate();
    const [isVisible, setVisible] = useState(null);
    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(null);
    const [historyGame, setHistoryGame] = useState(null);
    const [second, setSecond] = useState(0);
    const [minute, setMinute] = useState(1);
    const [start, setStart] = useState(false);
    const [dulieunhap, setDulieunhap] = useState(new Date());
    const [update, setUpdate] = useState(0);
    const date = new Date();
    const currentMinute = date.getMinutes();
    const currentSecond = date.getSeconds();
    const [total, setTotal] = useState(null);
    const [total2, setTotal2] = useState(null);
    const [setting, setSetting] = useState(null);
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const [newMoney, setNewMoney] = useState(null);
    const [message, setMessage] = useState(null);
    const [share, setShare] = useState(false);
    const [choose, setChoose] = useState([]);

    const handleBackClick = () => {
        navigate(-1);
    };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [activeOption, setActiveOption] = useState(null);

    const handleOptionClick = (option) => {
        setActiveOption(option);
        setNewMoney(Number(Number(option) * 1000).toLocaleString("vi-VN"));
    };
    useEffect(() => {
        document.querySelector(".point").style.animation = "movePointBack2 0.1s forwards";
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
            setProfile(res.data.data);
        });
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            setSetting(res.data.data[0]);
        });
        axios.get(`${process.env.REACT_APP_API_URL}/tx60s/get`).then((res) => {
            setBet(res.data.data);
            setDulieunhap(new Date(res.data.data.createdAt));
            setStart(true);
        });
        axios
            .get(`${process.env.REACT_APP_API_URL}/tx60s/getallbet`, {})
            .then((res) => {
                setTotal(res.data.data);
                setTotal2(res.data.data);
            })
            .catch(() => setTotal(null));
        getHistoryBet();
        getProfile();
    }, []);
    useEffect(() => {
        const timer = setInterval(() => {
            if (Math.floor(60 - (new Date() - dulieunhap) / 1000) < 0) {
                axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
                    setProfile(res.data.data);
                });
                axios.get(`${process.env.REACT_APP_API_URL}/tx60s/get`).then((res) => {
                    setBet(res.data.data);
                    setDulieunhap(new Date(res.data.data.createdAt));
                });
                axios
                    .get(`${process.env.REACT_APP_API_URL}/tx60s/getallbet`, {})
                    .then((res) => {
                        setTotal(res.data.data);
                        setTotal2(res.data.data);
                    })
                    .catch(() => setTotal(null));
                getHistoryBet();
                getProfile();
            }
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, [dulieunhap]);
    useEffect(() => {
        let curTime_second = Math.floor(60 - (date - dulieunhap) / 1000);

        let myTimeout;

        if (currentMinute === dulieunhap.getMinutes() && currentSecond === dulieunhap.getSeconds()) {
            setStart(true);
            setSecond(second - 1);
            return () => {
                clearTimeout(myTimeout);
            };
        } else if (curTime_second < 60 && curTime_second >= 0) {
            setSecond(curTime_second);
            setMinute((curTime_second - (curTime_second % 60)) / 60);
            setStart(true);
            return () => {
                clearTimeout(myTimeout);
            };
        } else {
            //cập nhật thời gian hiện tại 0.5s/lần
            myTimeout = setTimeout(() => {
                setUpdate(update + 1);
            }, 500);
        }
    }, [update, dulieunhap]);

    useEffect(() => {
        let curTime_second = Math.floor(60 - (date - dulieunhap) / 1000);
        let myTimeout = 0;
        if (start) {
            setSecond(curTime_second);
            setMinute(Math.floor(curTime_second / 60));

            if (curTime_second > 60 || curTime_second <= 0) {
                setStart(false);
                setMinute(1);
                setSecond(0);
                return () => {
                    clearTimeout(myTimeout);
                };
            }
            myTimeout = setTimeout(() => {
                setSecond(second - 1);
            }, 1000);
        }
        return () => {
            clearTimeout(myTimeout);
        };
    }, [second, start, dulieunhap]);

    function onChoose(num) {
        if ((choose.includes("6") && num === "5") || (choose.includes("5") && num === "6")) {
            //swal("Thông báo", "Không được phép đặt 2 cửa", "warning");
            //return;
        }
        if (choose.includes(num)) {
            setChoose(choose.filter((item) => item !== num));
        } else {
            setChoose([...choose, num]);
        }
    }
    const onSubmit = (e) => {
        e.preventDefault();
        if (newMoney == 0 || newMoney == null) {
            swal("Thất bại", "Bạn chưa nhập tiền", "error");
            return;
        }
        const formData = {
            result: choose.join(" "),
            id: bet._id,
            money: choose.length * Number(newMoney.replaceAll(".", "").replaceAll(",", ""))
        };
        if (formData.money > profile.money) {
            swal("Thất bại", "Số dư không đủ", "error");
            return;
        }
        if (Number(second) <= 10 && Number(minute) == 0) {
            swal("Đã hết thời gian cược", "Vui lòng chờ phiên tiếp theo", "info");
            return;
        }
        if (choose.length == 0) {
            swal("Thất bại", "Bạn chưa lựa chọn", "error");
            return;
        } else {
            axios
                .post(`${process.env.REACT_APP_API_URL}/history/chooseTX60s`, formData)
                .then((res) => {
                    swal({
                        title: "Đặt cược thành công",
                        icon: "success"
                    });
                    setChoose([]);
                    getProfile();
                    getHistoryBet();
                })
                .catch((err) => swal("Đã xảy ra lỗi", "Vui lòng tải lại trang", "error"));
        }
    };
    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    const [activeTab, setActiveTab] = useState("tab1");
    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        getHistoryBet();
    };

    function getHistoryBet() {
        axios
            .get(`${process.env.REACT_APP_API_URL}/history/historyus`, { params: { keyword: "TX60s" } })
            .then((res) => {
                setHistoryGame(res.data.data);
            })
            .catch((err) => function () {});
    }
    function getProfile() {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
            setProfile(res.data.data);
        });
    }
    const [datcuoc, setDatcuoc] = useState(false);
    const [dungcuoc, setDungcuoc] = useState(false);
    const [trathuong, setTrathuong] = useState(false);
    useEffect(() => {
        if (bet) {
            if (Number(second) === 1) {
                document.querySelector(".point").style.animation = "movePoint2 4s forwards";
                document.querySelector(".check").style.animation = "";
            } else if (Number(second) === 55) {
                document.querySelector(".point").style.animation = "movePointBack2 4s forwards";
                getHistoryBet();
                getProfile();
                setDatcuoc(true);
                setTimeout(function () {
                    setDatcuoc(false);
                }, 3000);
            } else if (Number(second) === 10) {
                setDungcuoc(true);
                setTimeout(function () {
                    setDungcuoc(false);
                }, 3000);
            } else if (Number(second) === 0) {
                setTrathuong(true);
                setTimeout(function () {
                    setTrathuong(false);
                }, 3000);
            } else if (Number(second) === 45) {
                document.querySelector(".point").style.animation = "shake 4s forwards";
                //document.querySelector(".check").style.animation = "shake1 4s forwards";
            } else if (Number(second) === 40) {
                //document.querySelector(".point").style.animation = "movePointBack2 4s forwards";
                document.querySelector(".check").style.animation = "";
            } else if (Number(second) < 40 && Number(second) > 2) {
                //document.querySelector(".point").style.animation = "movePointBack2 4s forwards";
                //document.querySelector(".check").style.animation = "";
            }
        }
    }, [second, bet]);

    return (
        <>
            {/* CSS BỔ SUNG ĐỂ ÉP CUỘN (SCROLL) MƯỢT MÀ VÀ STYLE CHO MODAL */}
            <style dangerouslySetInnerHTML={{__html: `
                .main.tx {
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    right: 0 !important;
                    bottom: 0 !important;
                    height: auto !important;
                    overflow-x: hidden !important;
                    overflow-y: auto !important;
                    -webkit-overflow-scrolling: touch !important;
                    padding-bottom: 100px !important;
                }
                
                /* Modal Tùy Chỉnh Nổi Lên Cực Đẹp */
                .tx-modal-overlay {
                    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.7); z-index: 999999;
                    display: flex; align-items: center; justify-content: center;
                    animation: fadeIn 0.2s ease-out;
                }
                .tx-modal-content {
                    background: #fff; width: 90%; max-width: 380px;
                    border-radius: 16px; padding: 20px 25px;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.3);
                    color: #333; animation: slideUp 0.3s ease-out;
                    position: relative;
                }
                .tx-modal-header {
                    font-size: 18px; font-weight: bold; text-align: center;
                    margin-bottom: 20px; color: #333; text-transform: uppercase;
                }
                .tx-modal-close {
                    position: absolute; right: 15px; top: 15px; font-size: 26px;
                    cursor: pointer; color: #888; line-height: 1; transition: 0.2s;
                }
                .tx-modal-close:active { transform: scale(0.9); color: #e74c3c; }
                
                .tx-modal-row {
                    display: flex; justify-content: space-between; align-items: center;
                    padding: 12px 0; border-bottom: 1px dashed #e0e0e0; font-size: 14px;
                }
                .tx-modal-row:last-child { border-bottom: none; }
                .tx-modal-row span:first-child { color: #666; font-weight: 500; }
                .tx-modal-row span:last-child { color: #222; font-weight: 700; text-align: right; max-width: 65%; word-break: break-word; }
                
                .tx-btn-close {
                    width: 100%; background: linear-gradient(90deg, #00b894, #00cec9); color: #fff; border: none;
                    border-radius: 8px; padding: 12px 0; font-size: 16px; font-weight: bold;
                    margin-top: 20px; cursor: pointer; transition: 0.2s; text-transform: uppercase;
                }
                .tx-btn-close:active { transform: scale(0.97); opacity: 0.9; }
                
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes slideUp { from { transform: translateY(30px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
            `}} />

            <div className="main tx">
                {/* NÚT QUAY LẠI THAY CHO HEADER CŨ */}
                <div style={{ height: "60px", width: "100%", position: "relative", zIndex: 99, flexShrink: 0 }}>
                    <div 
                        onClick={handleBackClick} 
                        style={{ position: "absolute", top: "12px", left: "15px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.5)", borderRadius: "50%", width: "36px", height: "36px" }}
                    >
                        <KeyboardArrowLeftOutlinedIcon style={{ color: "#fff", fontSize: "28px" }} />
                    </div>
                </div>

             
                <div className="box-bg-game" style={{ position: "relative" }}>
                    
                    {/* --- KHU VỰC HIỂN THỊ SỐ DƯ GÓC TRÊN BÊN PHẢI --- */}
                    <div style={{ 
                        position: "absolute", 
                        top: "10px", 
                        right: "15px", 
                        color: "#f2f2f2", 
                        fontSize: "14px",
                        background: "rgba(0, 0, 0, 0.5)", // Làm mờ nền một chút để số dư dễ đọc hơn
                        padding: "5px 12px",
                        borderRadius: "20px",
                        zIndex: 10 
                    }}>
                        <span>Số dư: </span>
                        <span style={{ color: "#00ff00", fontWeight: "bold" }}>
                            {profile?.money ? Math.floor(profile.money).toLocaleString("vi-VN") : "0"}
                        </span>
                    </div>
                    <div className="bg-game">
                        <div data-v-45adac70="" className="v_circle taste_lottery_countdown xodi  v_circle_show v_circle_PC">
                            <div data-v-45adac70="" className="mask full">
                                {second >= 30 && <div data-v-45adac70="" className="fill fix_l" style={{ transform: `rotate(${180 - (60 - second) * 6}deg)` }}></div>}
                            </div>
                            <div data-v-45adac70="" className="mask half">
                                {second < 30 ? (
                                    <div data-v-45adac70="" className="fill fix" style={{ transform: `rotate(${second * 6}deg)` }}></div>
                                ) : (
                                    <div data-v-45adac70="" className="fill fix" style={{ transform: `rotate(180deg)` }}></div>
                                )}
                            </div>
                            <div data-v-45adac70="" flex="main:center cross:center" className="pv">
                                <span data-v-45adac70="" className="progress">
                                    {second}
                                </span>
                            </div>
                        </div>
                        <div className="boxdia">
                            <img alt="" src={chen} className="point" style={{ animation: "movePointBack2" }} />
                            <img alt="" className="check" src={dia} />
                            {total && (
                                <div className="history_tx result-dia">
                                    {total[0].result.split(" ").map((item, index) => (
                                        <div key={index} className={`a${item}`}></div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="timexd">
                            <span style={{ fontSize: "0.4rem" }}>Phiên {bet?.id_bet}</span> <br />
                            <span style={{ opacity: "0.7" }}>{bet ? formatDate(new Date(bet.createdAt)) : null}</span>
                        </div>
                        {dungcuoc && (
                            <div className="game-noti dungcuoc">
                                <img src={require("../XDia/img/noti-dungcuoc.png")} alt="Dừng cược" />
                            </div>
                        )}
                        {datcuoc && (
                            <div className="game-noti datcuoc">
                                <img src={require("../XDia/img/noti-datcuoc.png")} alt="Đặt cược" />
                            </div>
                        )}
                        {trathuong && (
                            <div className="game-noti trathuong">
                                <img src={require("../XDia/img/noti-trathuong.png")} alt="Trả thưởng" />
                            </div>
                        )}
                    </div>
                </div>
                <div>
                    <button className={`taste_unit_item ${choose.includes("1") ? "active" : ""}`} onClick={(e) => onChoose("1")}>
                        <div className="taste_unit_img taste_unit_img_SHUANG"></div>
                        <div className="taste_unit_odds">{setting && setting.tx_c}</div>
                    </button>
                    <button className={`taste_unit_item ${choose.includes("2") ? "active" : ""}`} onClick={(e) => onChoose("2")}>
                        <div className="taste_unit_img taste_unit_img_DAN"></div>
                        <div className="taste_unit_odds">{setting && setting.tx_l}</div>
                    </button>
                    <button className={`taste_unit_item ${choose.includes("3") ? "active" : ""}`} onClick={(e) => onChoose("3")}>
                        <div className="taste_unit_img taste_unit_img_DA"></div>
                        <div className="taste_unit_odds">{setting && setting.tx_t}</div>
                    </button>
                    <button className={`taste_unit_item ${choose.includes("4") ? "active" : ""}`} onClick={(e) => onChoose("4")}>
                        <div className="taste_unit_img taste_unit_img_XIAO"></div>
                        <div className="taste_unit_odds">{setting && setting.tx_x}</div>
                    </button>
                </div>
                <div className="bet_taste_chips">
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "5" ? "active" : ""}`} onClick={() => handleOptionClick("5")}>
                        <div data-v-331b32c3="" flex="main:center cross:center" className="taste_chip">
                            <div data-v-331b32c3="" className="taste_chip_base taste_chip_10">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">5K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "10" ? "active" : ""}`} onClick={() => handleOptionClick("10")}>
                        <div data-v-331b32c3="" flex="main:center cross:center" className="taste_chip">
                            <div data-v-331b32c3="" flex="main:center cross:center" className="taste_chip_base taste_chip_25">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">10K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "50" ? "active" : ""}`} onClick={() => handleOptionClick("50")}>
                        <div data-v-331b32c3="" className="taste_chip">
                            <div data-v-331b32c3="" className="taste_chip_base taste_chip_50">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">50K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "100" ? "active" : ""}`} onClick={() => handleOptionClick("100")}>
                        <div data-v-331b32c3="" className="taste_chip">
                            <div data-v-331b32c3="" className="taste_chip_base taste_chip_100">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">100K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "500" ? "active" : ""}`} onClick={() => handleOptionClick("500")}>
                        <div data-v-331b32c3="" className="taste_chip">
                            <div data-v-331b32c3="" className="taste_chip_base taste_chip_200">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">500K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "1000" ? "active" : ""}`} onClick={() => handleOptionClick("1000")}>
                        <div data-v-331b32c3="" className="taste_chip">
                            <div data-v-331b32c3="" className="taste_chip_base taste_chip_500">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">1000K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "5000" ? "active" : ""}`} onClick={() => handleOptionClick("5000")}>
                        <div data-v-331b32c3="" className="taste_chip">
                            <div data-v-331b32c3="" className="taste_chip_base taste_chip_5">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">5000K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bet-input-panel bet_panel_taste">
                    <div data-v-331b32c3="" flex="main:justify box:justify cross:center" className="bet_taste_info">
                        <button
                            data-v-331b32c3=""
                            className="bet_taste_reset"
                            onClick={() => {
                                setActiveOption(null);
                                setNewMoney(null);
                            }}>
                            Đặt lại
                        </button>
                        <div data-v-331b32c3="" className="bet_taste_text">
                            <div data-v-331b32c3="" flex="main:center cross:center" className="bet_taste_num vi">
                                <span data-v-331b32c3="" className="bet_taste_text__common">
                                    Đã chọn
                                </span>
                                <span data-v-331b32c3="" className="bet_taste_text__protrude">
                                    {choose ? choose.length : 0}
                                </span>
                                <span data-v-331b32c3="" className="bet_taste_text__common">
                                    Lô
                                </span>
                            </div>
                            <div data-v-331b32c3="" flex="cross:center" className="bet_taste_money">
                                <input
                                    data-v-331b32c3=""
                                    flex-box="8"
                                    className="bet_taste_money_bet"
                                    min={1000}
                                    value={newMoney || ""}
                                    onChange={(e) => setNewMoney(e.target.value)}
                                    onClick={() => setActiveOption(null)}
                                    onKeyUp={(e) => setNewMoney(Number(e.target.value.replaceAll(".", "").replaceAll(",", "")).toLocaleString("vi-VN"))}
                                    name="money"
                                    type="text"
                                    placeholder="Nhập số tiền"
                                />
                            </div>
                        </div>
                        <button data-v-331b32c3="" className="bet_taste_submit" type="submit" onClick={onSubmit}>
                            Đặt cược
                        </button>
                    </div>
                </div>
                <div className="history_game">
                    <ul className="tab-navigation">
                        <li className={activeTab === "tab1" ? "active" : ""} onClick={() => handleTabClick("tab1")}>
                            Lịch sử trò chơi
                        </li>
                        <li className={activeTab === "tab2" ? "active" : ""} onClick={() => handleTabClick("tab2")}>
                            Lịch sử của tôi
                        </li>
                    </ul>

                    <div className="tab-content">
                        {activeTab === "tab1" && (
                            <div className="award_tb">
                                <table>
                                    <thead style={{ textAlign: "center" }}>
                                        <tr>
                                            <td>Phiên</td>
                                            <td>Kết quả</td>
                                            <td>Thời gian</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{bet && bet.id_bet}</td>
                                            <td style={{ textAlign: "center" }}>Đang chờ kết quả</td>
                                            <td>{bet && formatDate(new Date(bet.createdAt))}</td>
                                        </tr>
                                        {total2 &&
                                            total2.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item?.id_bet}</td>
                                                    <td
                                                        className="history_tx"
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center"
                                                        }}>
                                                        {item.result.split(" ").map((val, idx) => (
                                                            <div key={idx} className={`a${val}`}></div>
                                                        ))}
                                                    </td>
                                                    <td>{formatDate(new Date(item.createdAt))}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {activeTab === "tab2" && (
                            <>
                                {historyGame != null ? (
                                    <div className="content-history award_tb">
                                        {historyGame?.map((item, key) => (
                                            <div key={key}>
                                                {/* XÓA ĐIỀU KIỆN LỌC SẢNH KHỎI MÀN HÌNH NÀY CHỈ CÒN NHẬN DIỆN */}
                                                {item.sanh === "2" || item.sanh === "Tài xỉu 60s" ? (
                                                    <div
                                                        className="item_inner"
                                                        onClick={() => {
                                                            setLs(item);
                                                            setShow(true);
                                                        }}>
                                                        <div className="item_history">
                                                            <div className="title_item_history">
                                                                <span className="sanh" style={{ color: "#f5f5f5" }}>
                                                                    Tài xỉu 60s
                                                                </span>
                                                                <span
                                                                    className={`type_state ${
                                                                        item.status_bet === "Pending" ? "pending" : item.status_bet === "Win" ? "win" : "lose"
                                                                    }`}>
                                                                    {item.status_bet}
                                                                </span>
                                                            </div>
                                                            <div className="id_history_sanh">Phiên: {item?.id_bet?.id_bet ? item?.id_bet?.id_bet : item?.id_bet}</div>
                                                            <div className="id_history_sanh">{GetNameChoose(item.state, null, item.sanh || "Tài xỉu 60s")}</div>
                                                        </div>
                                                        <div className="money_history">
                                                            <span className="money" style={{ color: "#f2f2f2" }}>
                                                                {Number(item.money).toLocaleString("vi-VN")}
                                                            </span>
                                                            <div className="time_choose">{formatDate(new Date(item.createdAt))}</div>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                            </>
                        )}
                    </div>
                </div>

                {/* ===== MODAL CHI TIẾT POPUP MỚI NỔI LÊN GIỮA MÀN HÌNH ===== */}
                {isShow === true && ls && ls.status_bet !== "Pending" ? (
                    <div className="tx-modal-overlay" onClick={() => setShow(false)}>
                        <div className="tx-modal-content" onClick={(e) => e.stopPropagation()}>
                            
                            <span className="tx-modal-close" onClick={() => setShow(false)}>&times;</span>
                            
                            <div className="tx-modal-header">Chi tiết cược</div>
                            
                            <div className="tx-modal-row">
                                <span>Trò chơi</span>
                                <span>Tài xỉu 60s</span>
                            </div>
                            <div className="tx-modal-row">
                                <span>Phiên</span>
                                <span>{ls?.id_bet?.id_bet || ls?.id_bet || "Không xác định"}</span>
                            </div>
                            <div className="tx-modal-row">
                                <span>Thời gian</span>
                                <span>{formatDate(new Date(ls.createdAt))}</span>
                            </div>
                            <div className="tx-modal-row">
                                <span>Cửa đặt</span>
                                <span style={{ color: "#2ba1d8" }}>{GetNameChoose(ls.state, ls.type, ls.sanh || "Tài xỉu 60s")}</span>
                            </div>
                            <div className="tx-modal-row">
                                <span>Tổng cược</span>
                                <span style={{ color: "#e74c3c" }}>{Number(ls.money).toLocaleString("vi-VN")} ₫</span>
                            </div>
                            
                            {/* NẾU ĐÃ CÓ KẾT QUẢ THÌ HIỂN THỊ THÊM TIỀN THẮNG & KẾT QUẢ XÚC XẮC */}
                            {ls.status_bet !== "Pending" && (
                                <>
                                    <div className="tx-modal-row">
                                        <span>Tổng thắng</span>
                                        <span style={{ color: ls.status_bet === "Win" ? "#2ecc71" : "#e74c3c" }}>
                                            {Number(ls.moneythang || 0).toLocaleString("vi-VN")} ₫
                                        </span>
                                    </div>
                                    <div style={{ marginTop: "15px", textAlign: "center" }}>
                                        <div style={{ fontSize: "13px", color: "#666", marginBottom: "8px" }}>
                                            Kết quả phiên {ls?.id_bet?.id_bet || ls?.id_bet}
                                        </div>
                                        <div className="history_tx" style={{ display: "flex", justifyContent: "center", gap: "6px" }}>
                                            {ls.id_bet?.result?.split(" ").map((val, idx) => (
                                                <div key={idx} className={`a${val}`}></div>
                                            ))}
                                        </div>
                                    </div>
                                </>
                            )}
                            
                            <button className="tx-btn-close" onClick={() => setShow(false)}>ĐÓNG LẠI</button>
                        </div>
                    </div>
                ) : null}
            </div>
        </>
    );
}

export default TX60s;